import { Injectable } from '@angular/core';

@Injectable()
export class MessageService {

  
  constructor() { }

  showMessage(selector, msgColor, msgText, icon)
  {
    $(selector).removeClass();
    $(selector).addClass("alert " + msgColor + " alert-dismissible");
    $(selector).html('<h4><span class="glyphicon ' + icon + '"></span> ' + msgText + '</h4>');
    $(selector).show().delay(1000).fadeIn().delay(1000).fadeOut();

  }

}



// WEBPACK FOOTER //
// D:/xampp/htdocs/tejashree/src/app/services/message.service.ts